import request from '@/utils/seftRequest';

// 查询可用套餐
export function qryOfferList(params) {
  return request('/ding/custService/qryOfferListByAddr', {
    method: 'POST',
    body: params,
  });
}
// 查询套餐详情 drm/ding/subsService/qrySubsPlanDetailBsnl
export function qrySubsPlanDetailBsnl(params) {
  return request('/ding/subsService/qrySubsPlanDetailBsnl', {
    method: 'POST',
    body: params,
  });
}

// 查询临时套餐可切换套餐接口 /drm/ding/custService/qryExchangeablePlanBsnl
export function qryExchangeablePlanBsnl(data) {
  return request('/ding/custService/qryExchangeablePlanBsnl', {
    method: 'POST',
    body: data,
  });
}

// 查询资费描述接口 /drm/ding/custService/qrySubsPlanDesc
export function qrySubsPlanDesc(subsPlanId) {
  return request(`/ding/custService/qrySubsPlanDesc?subsPlanId=${subsPlanId}`);
}

// 获取可选scheme过滤条件
export function qrySalesRuleRefAttr(params) {
  return request('/ding/custService/qrySalesRuleRefAttr', { params });
}
